import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Clubs.css";

interface ClubData {
  Id: string;
  Name: string;
  ProfilePicture: string;
  Summary: string;
  CategoryNames: string[];
}

const Clubs: FC = () => {
  const [clubs, setClubs] = useState<ClubData[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [filteredClubs, setFilteredClubs] = useState<ClubData[]>([]);

  useEffect(() => {
    fetch("https://api.deceit.dev/clubs")
      .then((res) => res.json())
      .then((data) => {
        setClubs(data);
        setFilteredClubs(data);
      });
  }, []);

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    const filtered = clubs.filter(
      (club) =>
        club.Name.toLowerCase().includes(query) ||
        club.Summary.toLowerCase().includes(query) ||
        club.CategoryNames.some((cat) => cat.toLowerCase().includes(query)),
    );
    setFilteredClubs(filtered);
  }, [searchQuery, clubs]);

  return (
    <div className="Clubs">
      <h1 className="font-bold text-4xl mb-4">Active Clubs</h1>

      <input
        type="text"
        placeholder="Search clubs..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="px-4 py-2 border border-blue-900 bg-blue-950 rounded-sm mb-4 w-full max-w-md"
      />

      <div>
        {filteredClubs.map((club) => (
          <Link to={"/clubs/" + club.Id}>
            <div
              key={club.Id}
              className="bg-blue-950 truncate rounded-sm max-sm:py-3 border border-blue-900 hover:border-blue-400 shadow-md hover:shadow-2xl hover:cursor-pointer flex mb-3"
            >
              <img
                src={
                  club.ProfilePicture != null
                    ? `https://se-images.campuslabs.ca/clink/images/${club.ProfilePicture}?preset=large-sq`
                    : `https://se-images.campuslabs.ca/clink/images/9188f860-9ef4-4be5-978c-3ba4b792677e93b99350-90f7-4bd0-a73d-e010865272f5.jpg?preset=large-sq`
                }
                alt={club.Name}
                className="w-28 h-28 object-cover max-sm:w-16 p-2 max-sm:h-16 rounded-l-sm"
              />

              <div className="px-3 flex-wrap">
                <h2 className="text-xl font-bold text-gray-100 mb-2 text-wrap">
                  {club.Name}
                </h2>
                <p className="text-gray-300 text-sm mb-4 truncate text-wrap">
                  {club.Summary}
                </p>
                {club.CategoryNames.length > 0 &&
                  club.CategoryNames.map((category) => (
                    <div
                      key={category}
                      className="text-xs mr-1 inline-block bg-green-300 text-blue-950 font-bold px-2 py-1 rounded-sm text-wrap"
                    >
                      {category}
                    </div>
                  ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Clubs;
